/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleOrderDto
 */
export interface RuleOrderDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleOrderDto
     */
    orderedRuleIds: Array<string>;
}

/**
 * Check if a given object implements the RuleOrderDto interface.
 */
export function instanceOfRuleOrderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderedRuleIds" in value;

    return isInstance;
}

export function RuleOrderDtoFromJSON(json: any): RuleOrderDto {
    return RuleOrderDtoFromJSONTyped(json, false);
}

export function RuleOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleOrderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderedRuleIds': json['orderedRuleIds'],
    };
}

export function RuleOrderDtoToJSON(value?: RuleOrderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderedRuleIds': value.orderedRuleIds,
    };
}

